import React from 'react';
import { Box, Typography, Paper, Grid } from '@mui/material';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import StorageIcon from '@mui/icons-material/Storage';

export const BannerInfoServicesIa = () => {
    return (
        <Paper 
            elevation={0}
            sx={{ 
                mt: 3, 
                p: { xs: 3, md: 4 }, 
                backgroundColor: '#F8F7FA',
                borderRadius: 3,
                border: '1px solid #EAEAFF',
                mb: 3
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 3 }}>
                <Box sx={{ p: 1, borderRadius: '50%', backgroundColor: '#E8E7FD', display: 'flex', mr: 2 }}>
                    <SmartToyIcon sx={{ color: '#696CFF', fontSize: 32 }} />
                </Box>
                <Box>
                    <Typography variant="h6" sx={{ color: '#696CFF', fontWeight: 700, mb: 0.5, fontSize: '1.15rem' }}>
                        ¿Qué es la configuración de Servicios IA?
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500, maxWidth: '80%' }}>
                        Desde este módulo puedes administrar todos los modelos de Inteligencia Artificial que se conectan al sistema, definiendo sus costos, parámetros y disponibilidad.
                    </Typography>
                </Box>
            </Box>

            <Grid container spacing={3} sx={{ pl: { xs: 0, sm: 8.5 } }}>
                <Grid size={{xs: 12, md: 4}}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <DisplaySettingsIcon sx={{ color: '#696CFF', fontSize: 28 }} />
                        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Gestión de Modelos</Typography>
                        <Typography variant="body2" color="text.secondary">
                            Configura proveedores como OpenAI o Gemini, indicando su código técnico y tipo de servicio (Chat, Audio, etc).
                        </Typography>
                    </Box>
                </Grid>
                <Grid size={{xs: 12, md: 4}}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <MonetizationOnIcon sx={{ color: '#696CFF', fontSize: 28 }} />
                        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Control de Costos</Typography>
                        <Typography variant="body2" color="text.secondary">
                            Establece el precio por cada 1000 tokens de Input, Output y Caché para medir la rentabilidad del uso de IA.
                        </Typography>
                    </Box>
                </Grid>
                <Grid size={{xs: 12, md: 4}}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <StorageIcon sx={{ color: '#696CFF', fontSize: 28 }} />
                        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Límites y Capacidades</Typography>
                        <Typography variant="body2" color="text.secondary">
                            Define la ventana de contexto y los tokens máximos de salida soportados por el modelo para prevenir errores.
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    );
};
